import Slider from './Slider';
import DestacatBasic from 'components/corporatiu/Destacat/DestacatBasic/DestacatBasic';

const SliderDestacat = (props) => {
    const { items, routePath, titol, format, tema, icona, className, tipus } = props;

    return (
        <>
            {items && (
                <Slider titol={titol} fletxes='mig' format={format} tema={tema} className={className} tipus={tipus}>
                    {items.map((item, index) => {
                        return (
                            <div key={`slider-destacat-${index}`}>
                                <DestacatBasic item={item} mostrarImatge='true' icona={icona} routePath={routePath} tema={tema} />
                            </div>
                        );
                    })}
                </Slider>
            )}
        </>
    );
};

export default SliderDestacat;
